import React, { useState, useEffect } from 'react';

interface CryptoIconProps {
    ticker: string;
    size?: number; // Optional size prop
}

const CryptoIcon: React.FC<CryptoIconProps> = ({ ticker, size = 24 }) => {
    const iconName = ticker.toLowerCase();
    const iconPath = `/assets/crypto-icons/${iconName}.svg`;
    const [imgSrc, setImgSrc] = useState<string>(iconPath);

    useEffect(() => {
        const img = new Image();
        img.src = iconPath;
        img.onload = () => setImgSrc(iconPath);
        img.onerror = () => setImgSrc(`data:image/svg+xml;utf8,
      <svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}' viewBox='0 0 ${size} ${size}'>
        <circle cx='${size / 2}' cy='${size / 2}' r='${size / 2 - 2}' fill='grey' />
        <text x='50%' y='50%' font-family='Arial' font-size='${size / 3}' 
          text-anchor='middle' fill='white' alignment-baseline='central'>${ticker.toUpperCase()}</text>
      </svg>
    `);
    }, [ticker, iconName, iconPath, size]);

    return <img src={imgSrc} alt={ticker} style={{ width: size, height: size, maxWidth: size }} />;
};

export default CryptoIcon;
